module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Flip-vertical-5f3d2dcab725fae247bc78cfa42eb3ea.svg";